import { useEffect } from "react";
import { useLocation } from "wouter";
import { useAuth } from "@/hooks/useAuth";

export default function Profile() {
  const { user } = useAuth();
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (user?.id) {
      setLocation(`/profile/${user.id}`);
    }
  }, [user?.id, setLocation]);

  return null;
}
